import { ellipsis } from 'ellipsed';

export default class News {
    constructor() {
        this.init();
    }

    init() {

    }
}
